import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import BarLoader from "../Loader/BarLoader";
import { IconChevronDown, IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

export default function Table({
  data,
  columns,
  showHeaders,
  paginatorCheck,
  prevIsValid,
  nextIsValid,
  pageNo,
  records,
  totalRecord,
  pageChangeHandler,
  recordChangeHandler,
  loading,
  register = () => ({})
}) {
  
  return (
    <>
    
          {loading ? (
              <BarLoader />
              ) : (
          <>
            <DataTable
            value={data}
            emptyMessage={
              <h6 className="text-xs md:text-sm font-tbPop font-medium text-slate-600 md:text-center py-4">
                Data not found!
              </h6>
            }
            lazy={true}
            tableStyle={{ minWidth: "50rem" }}
            stripedRows
            resizableColumns="expand"
            showHeaders={showHeaders}
            rows={25}
            rowsPerPageOptions={[50, 75, 100]}
            header={columns.header}
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
                style={col.style ? "" : { width: "100%" }}
                className={col.className}
                headerClassName={col.headerClassName || col.className}
                bodyClassName={col.bodyClassName || col.className}
              />
            ))}
          </DataTable>

          {/* Custom Pagination */}
          {paginatorCheck && (
            <div className="flex items-center mt-3">
              {/* Left Side - Total Count */}
              {totalRecord !== undefined && (
                <p>
                  <span className="text-base-color font-semibold">Total Count</span>{" "}
                  - {totalRecord}
                </p>
              )}

              {/* Right Side - Pagination */}
              <div className="flex items-center gap-[8px] ml-auto">
                {prevIsValid && (
                  <button
                    onClick={() => pageChangeHandler(pageNo - 1)}
                    className="w-[56px] h-[39px] flex items-center justify-center bg-[#FAFAFA] border border-[#D3D3D3] rounded-[8px] hover:bg-gray-100 transition"
                  >
                    <IconChevronLeft stroke={1.5} size={23} color="#6B7280" />
                  </button>
                )}

                {nextIsValid && (
                  <button
                    onClick={() => pageChangeHandler(pageNo + 1)}
                    className="w-[56px] h-[39px] flex items-center justify-center bg-[#FAFAFA] border border-[#D3D3D3] rounded-[8px] hover:bg-gray-100 transition"
                  >
                    <IconChevronRight stroke={1.5} size={20} color="#6B7280"/>
                  </button>
                )}

                {/* Record size dropdown */}
                <div className="relative flex items-center justify-between w-[78px] h-[39px] px-[16px] py-[8px] gap-[8px] bg-[#FAFAFA] rounded-[8px] border border-[#D3D3D3]">
                  <select
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    {...register("recordSize", {
                      onChange: (e) => {
                        recordChangeHandler(e.target.value);
                      },
                    })}
                  >
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                  </select>

                  <span className="text-sm font-medium text-gray-700 pointer-events-none">
                    {records || 50}
                  </span>
                  <IconChevronDown stroke={1.5}  size={23} color="#6B7280" className="pointer-events-none"/>
                </div>
              </div>
            </div>
          )}
          </>)}
    </>
  );
}